import React from "react";
import cn from "classnames";
import "./Checkbox.scss";
import Form from "react-bootstrap/Form";
import {UseFormRegister, Path, FieldValues} from "react-hook-form";

// Тип для пропсов компонента Checkbox
interface CheckboxProps<T extends FieldValues> {
    className?: string;
    children?: React.ReactNode;
    name: Path<T>;
    register: UseFormRegister<T>;
    required?: boolean;
    errorMessage?: string;
    inputId?: string,
}

const Checkbox = <T extends FieldValues>(
    {
        className = "",
        children,
        name,
        register,
        required,
        errorMessage,
        inputId,
    }: CheckboxProps<T>) => {
    return (
        <div className={cn("checkboxGroup", {"checkboxError": errorMessage}, className)}>
            <Form.Check
                className={cn("inputCheckbox")}
                type="checkbox"
                id={`check-${name}-${inputId}`}
                isInvalid={!!errorMessage}
            >
                <Form.Check.Input
                    type="checkbox"
                    {...register(name, {required})}
                />
                <Form.Check.Label>
                    Я даю согласие на обработку моих
                    <a target="_blank" href="/assets/docx/obrabotka.pdf"> персональных данных</a>, а
                    также ознакомлен c <a target="_blank" href="/assets/docx/politika.pdf">условиями и
                    политикой</a> в отношении их обработки.
                </Form.Check.Label>
            </Form.Check>

            {errorMessage && (
                <span className="errorMessage">{errorMessage}</span>
            )}
        </div>
    );
};

export default Checkbox;
